import { css } from "lit";

export const styles = css`
  .status-dot {
    margin-right: var(--sds-size-space-300);
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .status-dot.sending {
    background: var(--sds-color-yellow-500);
    animation: dot-pulse 1.5s infinite;
  }

  .status-dot.scheduled {
    background: #4a90d9;
  }

  .status-dot.draft {
    background: var(--sds-color-yellow-400);
  }

  .status-dot.sent {
    background: var(--sds-color-green-500);
  }

  .status-dot.failed {
    background: var(--sds-color-red-500);
  }

  @keyframes dot-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
`;
